import type { CollectionItem } from '@/lib/blocks/collection/blocks';
import type { BlogRecord, ToCollectionItem } from '@/lib/blocks/collection/records';
import { readMoreButton } from './button';
import { blogHref } from './links';

export const blogToCollectionItem: ToCollectionItem<BlogRecord> = (blog, index, isPreview) => {
  const path = blogHref(blog, isPreview);
  const image = blog.image?.url ? blog.image : undefined;
  const title = blog.title ?? '';

  return {
    id: blog.id || blog.path || `blog-${index}`,
    path,
    image,
    imageTitle: title,
    topics: blog.topics ?? [],
    title,
    summary: blog.summary ?? '',
    authors: blog.authors ?? [],
    publishedAt: blog.publishedAt ?? '',
    button: readMoreButton(path),
  };
};

export function enrichBlogCollectionItem(item: CollectionItem): CollectionItem {
  const title = typeof item.title === 'string' ? item.title : '';
  const imageTitle =
    typeof item.imageTitle === 'string' && item.imageTitle.length > 0 ? item.imageTitle : title;

  return imageTitle === item.imageTitle ? item : { ...item, imageTitle };
}
